import type { VFC } from 'react';

import { CheckboxFilterGroup, FilterPanel } from '../../../generic/Filter';
import type { ExploitMaturity } from '../../../../../shared/issuesV2';
import type { SelectedOptionsProps } from '../../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: ExploitMaturity, label: string }> = [
  { key: 'has_known_exploit', label: 'Known Exploit' },
  { key: 'no_known_exploit', label: 'No Known Exploit' },
];

/**
 * Add a series of checkboxes for filtering Vuln Issues by "Exploit Maturity".
 */
const ExploitMaturityFilter: VFC<SelectedOptionsProps> = ({ selectedOptions, onSelect }) => {
  return (
    <FilterPanel>
      <CheckboxFilterGroup
        title="Exploit Maturity"
        options={FILTER_OPTIONS}
        selectedOptions={selectedOptions}
        onSelect={onSelect}
        testId="issues-vuln-exploit-maturity"
      />
    </FilterPanel>
  );
};

export default ExploitMaturityFilter;
